import React from "react";
import "./Home.css";
import Navbar from "../../components/Navbar/Navbar";
import slide_2 from "../../assests/images/slide_2.jpg";
import slide_4 from "../../assests/images/slide_4.jpg";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.switchImage = this.switchImage.bind(this);
    this.state = {
      currentImage: 0,
      images: [slide_2, slide_4],
    };
  }

  switchImage() {
    if (this.state.currentImage < this.state.images.length - 1) {
      this.setState({
        currentImage: this.state.currentImage + 1,
      });
    } else {
      this.setState({
        currentImage: 0,
      });
    }
    return this.currentImage;
  }

  componentDidMount() {
    setInterval(this.switchImage, 6000);
  }

  render() {
    return (
      <div className="home">
        <Navbar />
        <div className="main">
          <div className="main-text">
            <h1>Jesus Christ</h1>
            <h1>The Author and Finisher of our Faith</h1>
          </div>
          <div className="main-img">
            <div className="img">
              <img
                src={this.state.images[this.state.currentImage]}
                alt="Jesus"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Home;
